import { QuestionScore } from '~teacher/models/activities';
import { QuizQuestion } from '~teacher/models/quizzes';

import { add } from '../add';
import { effectiveQuestionWeight } from './effectiveQuestionWeight';

export const effectiveGradingWeightForQuestions = ({
  questions,
  questionScores = {},
}: {
  questions: QuizQuestion[];
  questionScores?: Record<number, QuestionScore>;
}) =>
  questions
    .map((question) => {
      const questionScore = questionScores
        ? questionScores[question.questionId]
        : null;
      return [question, questionScore] as const;
    })
    .map(([question, questionScore]) =>
      effectiveQuestionWeight({ question, questionScore })
    )
    .reduce(add, 0);
